import axios from 'axios'
import {config} from '../Config/config'

const pasienService = {
    getAll : () => {
        const result = axios.get(config.apiUrl + '/pasien')
        .then(respon => {
            return{
                success : respon.data.success,
                result : respon.data.result
            }
        })
        .catch(error =>{
            return{
                success : false,
                error : error
            }
        })
        return result
    },

    addData : (data) => {
        const result = axios.post(config.apiUrl + '/pasien', data)
        .then(respon => {
            return{
                success : respon.data.success,
                result : respon.data.result
            }
        })
        .catch(error =>{
            return{
                success : false,
                error : error
            }
        })
        return result
    },

    getByCustomerId : (id) => {
        const result = axios.get(config.apiUrl + '/pasienByCustomerId/' + id)
        .then(respon => {
            return{
                success : respon.data.success,
                result : respon.data.result[0]
            }
        })
        .catch(error =>{
            return{
                success : false,
                error : error
            }
        })
        return result
    },

    EditData : (data) => {
        const result = axios.put(config.apiUrl + '/pasien', data)
        .then(respon => {
            return{
                success : respon.data.success,
                result : respon.data.result
            }
        })
        .catch(error =>{
            return{
                success : false,
                error : error
            }
        })
        return result
    },

    DeleteData : (id) => {
        console.log(id)
        const result = axios.put(config.apiUrl + '/pasien_delete', id)
        .then(respon => {
            return{
                success : respon.data.success,
                result : respon.data.result
            }
        })
        .catch(error =>{
            return{
                success : false,
                error : error
            }
        })
        return result
    },

    getAllFilter : (filter) => {
        const result = axios.post(config.apiUrl + '/pasien_filter', filter)
        .then(respon => {
            return{
                success : respon.data.success,
                result : respon.data.result
            }
        })
        .catch(error =>{
            return{
                success : false,
                error : error
            }
        })
        return result
    },

    countData : (filter) => {
        const result = axios.post(config.apiUrl + '/count_pasien', filter)
        .then(respon => {
            return{
                success : respon.data.success,
                result : respon.data.result[0]
            }
        })
        .catch(error =>{
            return{
                success : false,
                error : error
            }
        })
        return result
    }
    
}


export default pasienService